var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noSite"},[_c('img',{staticClass:"noSite-img",attrs:{"src":require("@/assets/noSite.png")}}),_c('h1',{staticClass:"noSite-title"},[_vm._v("暂无站点")])])
}]

export { render, staticRenderFns }